import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemVariantOptionsMutation
 * @since 1.0.0
 */
export const ExportSaleItemVariantOptionsMutation = gql `
  mutation ExportSaleItemVariantOptionsMutation($input: ExportSaleItemVariantOptionsInput!) {
    exportSaleItemVariantOptions(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
